import { Component, OnInit } from '@angular/core';
import {state, style, transition, trigger, animate} from "@angular/animations";
import {TOAST_ICONS, ToastService} from "@ui-core/services/toast/toast.service";
import {IAlertModel} from "@shared/models/alerts/alerts.model";
import {Icon} from "@types-custom/models/ui/icon-model";

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastTrigger', [ // This refers to the @trigger we created in the template
      state('open', style({ transform: 'translateY(0%)' })), // This is how the 'open' state is styled
      state('close', style({ transform: 'translateY(200%)' })), // This is how the 'close' state is styled
      transition('open <=> close', [ // This is how they're expected to transition from one to the other
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class ToastComponent implements OnInit {
  protected readonly Icon = Icon;

  showToastMoved = false;
  message : IAlertModel = null

  constructor(
    public toast: ToastService
  ) { }

  ngOnInit(): void {
    this.toast.toastMessage$.subscribe((res : IAlertModel) => {
      this.message = res
    })
    this.toast.isComponentVisible$.subscribe((state : boolean) => {
      this.showToastMoved = state
    })
  }

  dismiss(): void {
    this.toast.dismissToast();
  }

  public generateIcon(layer: string) : Icon{
    // @ts-ignore
    return Icon[TOAST_ICONS[layer]]
  }
}
